// extracted by mini-css-extract-plugin
export default {"cls1":"X96Ltl6HGNy4K300wghb","cls2":"w9YTCuPkJIBX4lHKl7sc X96Ltl6HGNy4K300wghb"};